import { Editor } from '@tiptap/react';

interface Props {
  editor: Editor;
  characterLimit: number;
}
export const CharacterCounterProgress = ({ editor, characterLimit }: Props) => {
  const percentage = editor
    ? Math.round((100 / characterLimit) * editor.storage.characterCount.characters())
    : 0;

  return (
    <div
      className={`character-count px-[1.5rem] py-2 ${
        editor.storage.characterCount.characters() === characterLimit
          ? 'character-count--warning'
          : ''
      }`}>
      <svg height="20" width="20" viewBox="0 0 20 20">
        <circle r="10" cx="10" cy="10" fill="#e9ecef" />
        <circle
          r="5"
          cx="10"
          cy="10"
          fill="transparent"
          stroke="currentColor"
          strokeWidth="10"
          strokeDasharray={`calc(${percentage} * 31.4 / 100) 31.4`}
          transform="rotate(-90) translate(-20)"
        />
        <circle r="6" cx="10" cy="10" fill="white" />
      </svg>
      {editor.storage.characterCount.characters()} / {characterLimit} characters
      <br />
      {editor.storage.characterCount.words()} words
    </div>
  );
};
